// extracted by mini-css-extract-plugin
export default {"background":"Dialog_background__2lvI3","dialog":"Dialog_dialog__rErgh"};